/* eslint-disable max-len */
import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import * as questionIds from "./phq9QuestionIds";

export const masterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.IaptLittleInterestOrPleasureInDoingThings,
        questionText: "Little interest or pleasure in doing things",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptFeelingDownDepressedOrHopeless,
        questionText: "Feeling down, depressed, or hopeless",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptTroubleFallingOrStayingAsleepOrSleepingTooMuch,
        questionText: "Trouble falling or staying asleep, or sleeping too much",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptFeelingTiredOrHavingLittleEnergy,
        questionText: "Feeling tired or having little energy",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptPoorAppetiteOrOvereating,
        questionText: "Poor appetite or overeating",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptFeelingBadAboutYourself,
        questionText: "Feeling bad about yourself - or that you are a failure or have let yourself or your family down",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptTroubleConcentratingOnReadingOrWatching,
        questionText: "Trouble concentrating on things, such as reading the newspaper or watching television",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptMovingOrSpeakingSoSlowly,
        questionText: "Moving or speaking so slowly that other people could have noticed? Or the opposite - being so fidgety or restless that you have been moving around a lot more than usual",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptThoughtsThatWouldBeBetterOffDeadOrOfHurtingYourself,
        questionText: "Thoughts that you would be better off dead or of hurting yourself in some way",
        canBeDisabled: false
    }
];
/* eslint-enable max-len */
